<template>
  <div class="outline">
    <div class="leftRow">
      <div class="body">
        <img src="@/assets/image/logo.png" class="middleImg" />
        <div style="margin:4.444vh 0px 0px 3.0208vw;height:9.259vh">
          <div style="float:left">
            <div class="english">CULTURE</div>
          </div>
          <div class="chinese">武夷山文化</div>
        </div>
        <div class="footerMenu" >
          <div  v-for="item in dataSource" :key="item.id">
          <div class="culture-col"   @click="open(item.id)">
            <div class="column">
            <div class="">︻</div>
            <div class="culture-font">{{item.name}}</div>
            <div class="" style="margin-top:0.74074vh">︼</div>
            </div>
          </div>
          </div>
        </div>
      </div>
      <!-- <div class="bodyFlex">
        <div class="bodyFlexAlign">
          <img src="@/assets/image/logo.png" class="middleImg" />
          <div style="height:4.444vh"></div>
          <div style="display:flex;flex-direction:row;width:100%; justify-content:center;">
            <div class="english">CULTURE</div>
             <div class="chinese" style="margin-left: 0.46875vw;">武夷山文化</div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
  <!-- </div> -->
</template>

<script>
import "@/css/switch.css"
import { getMenuOpenList } from "@/api/common";
import Banner from "../../components/common/banner";
export default {
  name: "OutLine",
  components: { Banner },
  data() {
    return {
      dataSource: []
    };
  },
  mounted() {
    this.getInfoFunction()
  },
  methods: {
    //显示5个标题
    async getInfoFunction() {
      let pid = 0;
      let type = 1;
      let current = 1;
      let pageSize = 5;
      const { code, data } = await getMenuOpenList(pid, type, current, pageSize);
      if (code == 200) {
        this.dataSource = data.records
      }
    },
    open(type) {
      this.$store.commit("setChildMenu", 11);
      this.$store.commit("setTabPage", type);
      this.$store.commit("setShowSwitchMenu", false);
      let name = "CultureList";
      this.$emit("specialtyListFunction", name);
    }
  }
};
</script>

<style scoped>
.chinese {
  width: 0.9375vw;
  font-size: 1.6667vh;
  font-family: "Microsoft YaHei";
  font-weight: 400;
  color: #c45b0e;
  /* 文字竖排 */
  writing-mode: vertical-rl;
}
 .english {
  width: 0.7291vw;
  font-size: 1.4814vh;
  font-family: "Microsoft YaHei";
  font-weight: 400;
  color: #c45b0e;
  writing-mode: vertical-rl;
}
.middleImg {
  width: 15vh;
  height: 15vh;
  margin-top: 7.5vh;
}
.bodyFlex {
  display: flex;
  flex-direction: column;
}
.bodyFlexAlign {
  text-align: center;
  align-content: center;
}
.column {
  display: flex;
  flex-direction: column;
}
.column:hover {
  color: #c45b0e;
}
.culture-col {
  cursor: pointer;
  margin-left: 0.9895vw;
  margin-top: 5.3703vh;
  color: #005a51;
}
.culture-font {
  font-size: 1.48148vh;
  font-family: "Microsoft YaHei";
  font-weight: 400;
  /* height: 1.574vh;
  line-height: 1.574vh; */
}
</style>



// WEBPACK FOOTER //
// src/views/culture/cultureSwitch.vue